export const ConfigSymbol = Symbol('config');
